import React, { useEffect } from 'react';
import './comingsoon.css';
import backGround from '../../assets/seamless@300x1.jpg';
import Footer from '../../components/footer/Footer'
import Header from '../../components/Header/Header'
import { useStateValue } from '../../stateprovider';

export default function Comingsoon() {
    const [{ menu }, dispatch] = useStateValue();

    useEffect(() => {
        dispatch({
            type: "MENU",
            menu: false
        });
        dispatch({
            type: "ACTIVE_NAVIGAtION",
            navigation: ''
        });

    }, [])
    return (
        <>
            <div className="Comingsoon">
                <Header />
                <div className={(menu === true) ? 'notDisplay' : "Comingsoon__CongratsSection"}>

                    <div className="Comingsoon__SignUpMessage">
                        <h2><span>Page doesn't exist</span></h2>

                    </div>
                </div>
                <div className={(menu === true) ? 'notDisplay' : "footer"}>
                    <Footer />
                </div>

            </div>
            <div className={(menu === true) ? 'notDisplay' : "Comingsoon__BackgroundImage"}>
                <img src={backGround} alt="Favourite Doctor Background" />
            </div>
        </>
    )
}
